export const DEFAULT_INITIAL_DATE = '1000-01-01T00:00:00Z';

export const isEmptyDate = (date: string | null): boolean => !date || date === DEFAULT_INITIAL_DATE;

export function formatISO8601WithOffset(date = new Date()) {
  const pad = (n: number) => String(n).padStart(2, '0');

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  // Timezone offset in minutes, note: getTimezoneOffset returns minutes *behind* UTC
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const offsetHours = pad(Math.floor(absMinutes / 60));
  const offsetMins = pad(absMinutes % 60);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMins}`;
}

export function formatDateAMPM(date: Date) {
  const month = date.getMonth() + 1; // Meses van de 0 a 11
  const day = date.getDate();
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convertir 0 a 12 para AM

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
}
export const separateDateValues = (date: Date) => [
  date.getFullYear(),
  date.getMonth() + 1,
  date.getDate(),
  date.getHours(),
  date.getMinutes(),
  date.getSeconds(),
  date.getMilliseconds()
];
